import _ from "lodash";
import { Cookies } from "react-cookie";
import {
  listenFirebaseUsersData,
  unlistenFirebase,
} from "../../api/firebase/firebaseOn";
import { sendGoogleAnalytics } from "../../api/google";
import {
  EMAIL,
  GET_SIGNUP_DATA,
  RESET_LOGIN,
  RESET_ORDER,
  RESET_PASSWORD_ERROR,
  SHOW_CONNEXION_MODAL,
  SHOW_FORGET_PASSWORD,
  SHOW_SIGNUP,
  UPDATE_PROFILE,
  USER_CONNECTION,
  USER_CONNECTION_ERROR,
  USER_SIGNUP_ERROR,
  USER_START_CONNECTION,
  USER_START_RESET_PASSWORD,
  USER_REQUIRE_VERIFICATION,
} from "./types";
import { AUTH_TYPES, ORDER_TYPE_CLICK_AND_SEAT } from "../../constants";
import { showSignUp, showSplash } from "./componentAction";
import {
  getCookieCustomerId,
  getWebViewCustomerId,
  resetCookieCustomerId,
  setCookieCustomerId,
} from "../../utils/customer";
import { getShopIdFromLink } from "../../utils/shop";
import { isQrCode, isWebView } from "../../utils/config";
import {
  anonymousUserConnexion,
  forgetPasswordUser,
  generatePendingUserFlag,
  getIdToken,
  signInUser,
  signOut,
  signUpUser,
} from "../../api/firebase/firebaseAuthentication";
import {
  checkCustomerExistenceBackend,
  createCustomerBackend,
  deleteCustomerAccountBackend,
  getCustomerBackend,
} from "../../api/backend";
import { getFirebaseAuth } from "../../api/firebase/firebaseInit";
import { getShopAddress } from "../../api/shops";
import { updateAddress } from "./pendingOrderAction";
import {
  generateCustomerAddress,
  getCustomerAddress,
  setUserPendingOrderAddressAndOrderTypeFirebase,
} from "../../utils/customer-address-and-shops";
import { isStringNotNull } from "../../utils";
import store from "../store";
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  updateProfile as updateProfileFirebase,
} from "firebase/auth";
import {
  analyticsEvents,
  PAGE_TYPES,
  PAGES,
  PROVENANCE,
} from "../../utils/firebaseAnalytics";
import { transferCustomerData, decision2FA, getUserLoyaltyPoints } from "../../api/users";
import { logLowError, logLowLog, logMediumError } from "../../utils/logger";
import { normalizeEmail } from "../../utils/customer";
export const userConnection = (email, password) => async (dispatch) => {
  try {
    const normalizedEmail = normalizeEmail(email);
    logLowLog(`User ${normalizedEmail} connecting`);
    dispatch({ type: USER_START_CONNECTION });
    const decision = await decision2FA(normalizedEmail);
    if (!decision?.emailVerificationRequired) {
      dispatch(loginAndHandleSuccess(normalizedEmail, password));
      sendGoogleAnalytics("login", { method: "firebase" });
      analyticsEvents.logLogin(AUTH_TYPES.INTERNAL);
      return;
    }
    await signInUser(normalizedEmail, password);

    dispatch({
      type: USER_REQUIRE_VERIFICATION,
      payload: {
        email: normalizedEmail,
      },
    });
    await signOut();
  } catch (error) {
    handleLoginError(dispatch, error);
  }
};
export const loginAndHandleSuccess = (normalizedEmail, password) => {
  return async (dispatch, getState) => {
    const customerId = await signInUser(normalizedEmail, password);
    await userConnectionSuccess(
      dispatch,
      getState,
      customerId,
      false,
      true,
      true,
    );
  };
};
const shouldLogLoginError = (errorMessage) => {
  const ignoredErrors = [
    "auth/too-many-requests",
    "auth/wrong-password",
    "auth/user-not-found",
    "auth/account-exists-with-different-credential",
  ];

  return !ignoredErrors.some((message) => errorMessage.includes(message));
};

export const handleLoginError = (dispatch, error) => {
  const errorMessage = String(error);

  if (shouldLogLoginError(errorMessage)) {
    logMediumError(`Could not login: ${errorMessage}`);
  }
  dispatch({ type: USER_CONNECTION_ERROR, payload: errorMessage });
};
export const facebookOrGoogleSignUp =
  (profile, loginMethod) => async (dispatch, getState) => {
    try {
      logLowLog(`Creating new account`);
      await createCustomerBackend(profile);
      await facebookOrGoogleLogin(
        dispatch,
        getState,
        loginMethod,
        profile.id,
        true,
        false,
      );
    } catch (error) {
      dispatch({
        type: USER_CONNECTION_ERROR,
        payload: `Nous n'avons pas pu vous connecter via ${loginMethod}! Veuillez réessayer`,
      });
    }
  };

export const facebookOrGoogleLogin = async (
  dispatch,
  getState,
  loginMethod,
  customerId,
  triggerDataTransfer = false,
  triggeredByLogin = true,
) => {
  logLowLog(`User connecting with ${loginMethod}`);
  dispatch({ type: USER_START_CONNECTION });
  await userConnectionSuccess(
    dispatch,
    getState,
    customerId,
    false,
    triggerDataTransfer,
    triggeredByLogin,
  );
  sendGoogleAnalytics("login", { method: loginMethod });
  analyticsEvents.logLogin(loginMethod);
};

export const facebookOrGoogleSignIn =
  (loginMethod) => async (dispatch, getState) => {
    try {
      const provider =
        loginMethod === AUTH_TYPES.GOOGLE
          ? new GoogleAuthProvider()
          : new FacebookAuthProvider();
      provider.addScope("email");
      const auth = getFirebaseAuth();
      auth.languageCode = "fr_FR";
      const response = await signInWithPopup(auth, provider);
      const { user } = response;
      const email = user?.providerData[0]?.email;
      const isNewUser =
        user?.metadata?.creationTime === user?.metadata?.lastSignInTime;
      const { uid, displayName } = response.user;
      const firstName = displayName.split(" ")[0];
      const lastName = displayName.split(/ (.+)/)[1];
      if (isNewUser) {
        await updateProfileFirebase(user, {
          displayName: `${displayName} ${generatePendingUserFlag(uid)}`,
        });
        await dispatch(
          getSignUpData({ firstName, lastName, email, uid, loginMethod }),
        );
        dispatch(showSignUp(true));
        analyticsEvents.logSignUp(loginMethod);
        analyticsEvents.logPageViewEvent(
          PAGES.SIGN_UP,
          PROVENANCE.LOGIN_PAGE,
          PAGE_TYPES.EXTERNAL,
        );
      } else {
        await facebookOrGoogleLogin(
          dispatch,
          getState,
          loginMethod,
          uid,
          true,
          true,
        );
      }
    } catch (error) {
      const errorMessage = String(error);
      if (
        !errorMessage.includes("auth/popup-closed-by-user") &&
        !errorMessage.includes("The popup has been closed by the user") &&
        !errorMessage.includes("auth/cancelled-popup-request") &&
        !errorMessage.includes("auth/user-cancelled") &&
        !errorMessage.includes(
          "auth/account-exists-with-different-credential",
        ) &&
        !errorMessage.includes("auth/network-request-failed") &&
        !errorMessage.includes("auth/popup-blocked") &&
        !errorMessage.includes("auth/invalid-credential")
      ) {
        logMediumError(`Could not login with ${loginMethod}: ${errorMessage}`);
      }
      dispatch({
        type: USER_CONNECTION_ERROR,
        payload: `Nous n'avons pas pu vous connecter via ${loginMethod}! Veuillez réessayer`,
      });
    }
  };

export const userSignUp =
  (email, password, nom, prenom, telephone, phoneObj, newsletter) =>
    async (dispatch, getState) => {
      try {
        const normalizedEmail = normalizeEmail(email);
        logLowLog(`User ${email} getting sign up`);
        dispatch({ type: USER_START_CONNECTION });
        const customerId = await signUpUser(
          normalizedEmail,
          password,
          nom,
          prenom,
          telephone,
          phoneObj,
          newsletter,
        );
        dispatch({ type: USER_SIGNUP_ERROR, payload: "" });
        dispatch({
          type: SHOW_SIGNUP,
          payload: false,
        });
        dispatch({
          type: SHOW_CONNEXION_MODAL,
          payload: false,
        });
        dispatch({
          type: EMAIL,
          payload: null,
        });
        userConnectionSuccess(dispatch, getState, customerId, false, true, false);
        sendGoogleAnalytics("sign_up", { method: "firebase" });
        analyticsEvents.logSignUp(AUTH_TYPES.INTERNAL);
      } catch (error) {
        deleteCustomerAccountBackend();
        userSignOutFromRedux(dispatch, getState);
        let errorMessage = String(error);
        if (!error) {
          errorMessage = "auth/error-signup";
        }
        if (
          !errorMessage.includes("auth/email-already-in-use") &&
          !errorMessage.includes("auth/weak-password")
        ) {
          logMediumError(`Could not signup ${errorMessage}`);
        }
        dispatch({ type: USER_SIGNUP_ERROR, payload: errorMessage });
      }
    };

export const resetEmail = () => (dispatch) => {
  dispatch({ type: EMAIL, payload: null });
};

export const userForgetPassword = (email) => async (dispatch) => {
  try {
    logLowLog(`User ${email} resets his passwoard`);
    dispatch({ type: USER_START_RESET_PASSWORD });
    await forgetPasswordUser(email);
    dispatch({ type: RESET_PASSWORD_ERROR, payload: "" });
    dispatch({
      type: SHOW_FORGET_PASSWORD,
      payload: false,
    });
  } catch (error) {
    const errorMessage = String(error);
    if (!errorMessage.includes("user-not-found")) {
      logMediumError(`Could not forget password ${errorMessage}`);
    }

    dispatch({ type: RESET_PASSWORD_ERROR, payload: errorMessage });
  }
};

export const listenerAuth = () => {
  onAuthStateChanged(getFirebaseAuth(), async (user) => {
    const { uid, providerData = [] } = user || {};
    if (!user?.uid) {
      store.dispatch({
        type: USER_CONNECTION,
        payload: { user: {}, isUserAnonymous: true },
      });
      store.dispatch(userSignOut());
      return;
    }
    const userExists = await checkCustomerExistenceBackend(uid);
    if (userExists) {
      await userConnectionSuccess(
        store.dispatch,
        store.getState,
        uid,
        user.isAnonymous,
        user.isAnonymous,
        false,
      );
      return;
    }
    const isAnonymousUser = _.isEmpty(providerData);
    if (isAnonymousUser) {
      await userConnectionSuccess(
        store.dispatch,
        store.getState,
        uid,
        user.isAnonymous,
        user.isAnonymous,
        false,
      );
      return;
    }
    const isPendingUser = user?.displayName?.endsWith(
      generatePendingUserFlag(uid),
    );
    if (isPendingUser) {
      return;
    }
  });
};

export const userConnectionCheck = async () => {
  try {
    const webView = isWebView();
    const qrCode = isQrCode();

    if (webView || qrCode) {
      let customerId = getCookieCustomerId();
      const shopId = getShopIdFromLink();
      await userSignOutFromRedux(store.dispatch, store.getState);
      if (webView) {
        if (customerId) {
          const { customerAddress: address, shopId: pendingOrderShopId } =
            await getCustomerAddress(customerId, true);

          if (!address || pendingOrderShopId !== shopId) {
            customerId = null;
          }
        }
        customerId = getWebViewCustomerId();
        await userConnectionSuccess(
          store.dispatch,
          store.getState,
          customerId,
          true,
          false,
        );
        return;
      }
      return await handleQrCodeConnection(
        customerId,
        shopId,
        ORDER_TYPE_CLICK_AND_SEAT,
      );
    }

    listenerAuth();
  } catch (error) {
    logMediumError(`Error checking user: ${error}`);
  }
};

const handleQrCodeConnection = async (customerId, shopId, orderType) => {
  try {
    logLowLog("Creating QR code customer backend");
    if (!customerId) {
      customerId = await anonymousUserConnexion();
      await getIdToken(true);
      setCookieCustomerId(customerId);
    }

    await store.dispatch(async (dispatch, getState) => {
      await userConnectionSuccess(dispatch, getState, customerId, true, false);
    });
    const address = await getShopAddress(shopId);
    const customerAddress = generateCustomerAddress(address);
    await setUserPendingOrderAddressAndOrderTypeFirebase(
      customerId,
      shopId,
      customerAddress,
      orderType,
    );
    return customerId;
  } catch (error) {
    logMediumError(`Could not create customer backend: ${error}`, {
      customerId,
      shopId,
      orderType,
    });
  }
};

export const userSignOut = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_CONNECTION,
      payload: { user: {}, isUserAnonymous: true },
    });

    const { user } = getState().userReducer;
    if (user) {
      unlistenFirebase(user.customerId);
    }
    await signOut();
    dispatch({ type: RESET_ORDER });
    showSplash(dispatch, false);
    analyticsEvents.logLogout();
  } catch (error) {
    logLowError("Could not sign out");
  }
};

export const userSignOutFromRedux = async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_CONNECTION,
      payload: { user: {}, isUserAnonymous: true },
    });

    const { user } = getState().userReducer;
    if (user) {
      unlistenFirebase(user.customerId);
    }
    //  await signOut();
    const newCustomerAddress = new Cookies().get("address");
    updateAddress(newCustomerAddress, dispatch);
    resetCookieCustomerId();
    dispatch({ type: RESET_ORDER });
  } catch (error) {
    logLowError("Could not sign out");
  }
};

export const userConnectionSuccess = async (
  dispatch,
  getState,
  customerId,
  isUserAnonymous,
  triggerDataTransfer = false,
  triggeredByLogin = false,
) => {
  const { user: stateUser } = store.getState().userReducer;
  const userExists = await checkCustomerExistenceBackend(customerId);
  const customerProfile = userExists
    ? await getCustomerBackend(customerId)
    : null;
  if (customerProfile || isUserAnonymous) {
    if (
      isStringNotNull(stateUser?.customerId) &&
      isStringNotNull(customerId) &&
      triggerDataTransfer &&
      customerId !== stateUser?.customerId
    ) {
      await transferCustomerData(
        stateUser.customerId,
        customerId,
        triggeredByLogin,
      );
    }
    await getIdToken(true);
    // Listen real time firebase data (needs to be done after updating address)
    await listenFirebaseUsersData(customerId, isUserAnonymous, updateUser);

    // Update user info
    updateUser(customerProfile, customerId, isUserAnonymous, dispatch);
    // hide splash
  } else {
    logLowLog(`User ${customerId} without data`);
    await userSignOutFromRedux(dispatch, getState);
    dispatch({ type: USER_CONNECTION_ERROR, payload: "auth/no-user-data" });
  }
  showSplash(dispatch, false);
};

export const updateUser = (userInfo, customerId, isUserAnonymous, dispatch) => {
  if (dispatch) {
    dispatch({
      type: USER_CONNECTION,
      payload: {
        user: { ...userInfo, customerId },
        isUserAnonymous,
      },
    });
  } else {
    return {
      type: USER_CONNECTION,
      payload: {
        user: { ...userInfo, customerId },
        isUserAnonymous,
      },
    };
  }
};

export const updateProfile = (attribute, value, dispatch) => {
  if (dispatch) {
    dispatch({ type: UPDATE_PROFILE, payload: { attribute, value } });
  } else {
    return { type: UPDATE_PROFILE, payload: { attribute, value } };
  }
};

export const resetLogin = () => ({
  type: RESET_LOGIN,
});

export const getSignUpData = (signUpData) => {
  return {
    type: GET_SIGNUP_DATA,
    payload: signUpData,
  };
};
export const updateUserLoyaltyPoints = async (
  customerId,
  isUserAnonymous,
  dispatch,
) => {
  const { companyId } = store.getState().configurationReducer;
  const { user } = store.getState().userReducer;

  const customerIdData = user?.customerId || customerId;

  if (!customerIdData || !companyId) {
    return;
  }

  const userPoints = await getUserLoyaltyPoints(
    companyId,
    customerIdData,
  );

  updateUser(
    { ...user, points: userPoints ?? 0 },
    customerIdData,
    isUserAnonymous,
    dispatch,
  );
}